import axiosInstance from 'src/utils/axios';
import {
  ActiveThemeForMerchantResponse,
  CarbonClickTheme,
  GetForMerchantThemeResponse,
  GetPortalConfigurationResponse,
  SaveImageForMerchantPayload,
  SaveThemeForMerchantPayload,
} from './types.api';

//
//

const BASE_URL = '/cms/v1';

//

export async function sendTestEmailAPI(data: any) {
  return axiosInstance.post(`${BASE_URL}/send-test-purchase-completed-email`, JSON.stringify(data));
}

// theme

export const getActiveThemeForMerchantAPI = async (
  merchantCode: string
): Promise<ActiveThemeForMerchantResponse> => {
  const response = await axiosInstance.get<ActiveThemeForMerchantResponse>(
    `${BASE_URL}/themes/active`,
    { params: { merchantCode } }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const saveThemeForMerchantAPI = async (payload: SaveThemeForMerchantPayload) => {
  const themeResponse = await saveThemeAPI(payload.theme);
  const themeId = themeResponse.data.id;
  return connectMerchantToThemeAPI(payload.merchantCode, themeId);
};

const saveThemeAPI = async (theme: CarbonClickTheme) => {
  return axiosInstance.post(`${BASE_URL}/themes/`, JSON.stringify(theme));
};

const connectMerchantToThemeAPI = async (merchantCode: string, themeId: string) => {
  return axiosInstance.post(`${BASE_URL}/themes/${themeId}/merchant/${merchantCode}`);
};

//

export const saveImageForMerchantAPI = async (
  payload: SaveImageForMerchantPayload
): Promise<string> => {
  const formData = new FormData();
  formData.append('file', payload.file);
  const config = {
    params: { imageType: payload.imageType },
    headers: { 'Content-Type': 'multipart/form-data' },
  };

  const configTypeParam = payload?.configType ? `/${payload.configType}` : '';
  const response = await axiosInstance.post(
    `${BASE_URL}/images/merchant/${payload?.merchantCode}${configTypeParam}`,
    formData,
    config
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

// components

export const getActivePortalConfigurationAPI = async (
  merchantCode: string
): Promise<GetPortalConfigurationResponse> => {
  const response = await axiosInstance.get<GetPortalConfigurationResponse>(
    `${BASE_URL}/components/merchant-portal`,
    { params: { merchantCode } }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getForMerchantThemeAPI = async (
  merchantCode: string
): Promise<GetForMerchantThemeResponse> => {
  const response = await axiosInstance.get<GetForMerchantThemeResponse>(
    `${BASE_URL}/components/transaction-details`,
    { params: { merchantCode } }
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
